// 通用工具类
// RSA 加密密钥
const PUB = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC5gsH+AA4XWONB5TDcUd+xCz7ejOFHZKlcZDx+pF1i7Gsvi1vjyJoQhRtRSn950x498VUkx7rUxg1/ScBVfrRxQOZ8xFBye3pjAzfb22+RCuYApSVpJ3OO3KsEuKExftz9oFBv3ejxPlYc5yq7YiBO8XlTnQN0Sa4R4qhPO3I2MQIDAQAB-----END PUBLIC KEY-----'
import ucon from '../util/constant'
// 主色样式模板
// 马上检查是否需要降级到同步
if (window.Worker) {
  try {
    var myworkertest = new Worker(URL.createObjectURL(new Blob()))
    myworkertest.onerror = function () {
      try {
        window.Worker = null
      } catch (e) { }
    }
  } catch (e) {
    try {
      window.Worker = null
    } catch (e) {}
  }
}
const cssTemplate = `.c-main>button{background:{mainColor} !important;}.c-main>a,.c-main>a:active,.c-main>a:hover,.c-main>strong{color:{mainColor} !important}.c-main.u-btn-sms>button{color:{mainColor} !important;background:#fff!important;border-left:1px solid #d0d0d0!important}.c-main .i-checkbox.checked{background-color:{mainColor} !important;}`
const commonMail = {
  'qq.com': `https://mail.qq.com`,
  'sina.com': `https://mail.sina.com`,
  'foxmail.com': `http://mail.foxmail.com`,
  'sohu.com': `https://mail.sohu.com`,
  'vip.qq.com': `http://mail.vip.qq.com`,
  'live.com': `https://mail.live.com`,
  '139.com': `https://mail.139.com`,
  'tom.com': `http://mail.tom.com`,
  'icloud.com': `https://mail.icloud.com`,
  'aliyun.com': `https://mail.aliyun.com`,
  'edu.tw': `http://mail.edu.tw`
}
// 灰度100%
var NEEDSM = 1
import md5 from 'md5'
// bowser不能升级。4.1.2android
import bowser from 'bowser'
import codemapper from '../util/codemapper'
import sm4 from './sm4'
const sm4pubkey = 'BC60B8B9E4FFEFFA219E5AD77F11F9E2'

var capfailcount = 0
const CAPCODEMAP = {
  '441': 1,
  '444': 4,
  '445': 5,
  '447': 6
}
export default {
  filterMsg (btntxt) {
    btntxt = btntxt.trim(/ /g, '')
    return `验证失败，请再次点击${btntxt}按钮`
  },
  getCodeMessage (res, api) {
    let defaultTxt = `网络异常，请稍后再试`
    let code = res.ret || res
    let dt = res.dt || ``
    let dtcode = code
    let apicode
    if (dt) {
      dtcode = `${code}_${dt}`
    }
    apicode = `${api}_${dtcode}`
    let txt = codemapper[apicode] || codemapper[code] || defaultTxt
    return txt
  },
  getCapFlagByCode (code) {
    return CAPCODEMAP[code]
  },
  /**
   * 判断是移动端
   */
  isMobile () {
    return !!bowser.mobile
  },
  /**
   * 二次校验失败计数
   */
  CapFailCount (add) {
    if (add) {
      capfailcount++
    }
    return capfailcount >= 5
  },
  /**
   * 动态生成一个确认链接
   */
  createConfirm (un) {
    return function () {
      un = encodeURIComponent(un)
      let promark = ucon.promark
      window.open(`https://id.163.com/mail/login.html?promark=${promark}&username=${un}&curl=https%3A%2F%2Fid.163.com%2Fmail%2Fverify.html%23%2FbindMobile`)
    }
  },
  createUnlock (un) {
    return function () {
      un = encodeURIComponent(un)
      window.open(`https://id.163.com/mail/unlock.html?username=${un}`)
    }
  },
  /**
   * 动态生成一个确认链接
   */
  createVerifyLink (un) {
    return function () {
      let pkid = ucon.promark
      let pd = ucon.product
      window.open(`https://id.163.com/mail/stable.html?username=${un}&source=zjlogin&product=${pd}&zj_promark=${pkid}`)
    }
  },
  /**
   * 动态生成一个确认链接
   */
  createLogoutConfirm (un) {
    return function () {
      un = encodeURIComponent(un)
      window.open(`https://id.163.com/mail/logoutQuery.html?username=${un}`)
    }
  },
  /**
   * 动态生成vip链接
   */
  createVipLinkConfirm (sign, product) {
    return function () {
      sign = encodeURIComponent(sign)
      window.open(`https://vpay.vip.163.com/center/index.html?sign=${sign}&from=${product}&utm_source=${product}`)
    }
  },
  /**
   * 动态生成找回密码链接
   */
  createFindPwdConfirm (un) {
    return function () {
      un = encodeURIComponent(un)
      window.open(`https://id.163.com/mail/retrievepassword?h5dl=1&username=${un}`)
    }
  },
  createMailLinkHelp () {
    return function () {
      window.open(`https://hc.reg.163.com/webcomponentH5/doc.html?id=552&itemid=320`)
    }
  },
  createMailLink (url) {
    return function () {
      window.open(url)
    }
  },
  hasMailLink (un) {
    let suffix = un.split(`@`)[1]
    return commonMail[suffix]
  },
  /**
   * 插入一个隐藏的iframe
   * @param {string} url
   * @param {function} loadfunc
   */
  insertFrame (url, opd, loadfunc) {
    // https强制转换
    if (location.protocol === 'https:') {
      url = url.replace('http:', 'https:')
    }
    // 加上opd参数
    url = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'opd=' + opd
    url = this.tryAddSm(url).realurl
    // 创建iframe
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.addEventListener('load', () => {
      loadfunc()
    })
    document.body.appendChild(iframe)
    // 强制异步，保证load事件监听先加上
    window.setTimeout(function () {
      iframe.src = url
    }, 0)
  },
  /**
   * 追加页面主色样式
   * @param {string} mainColor
   */
  appendMainColor (mainColor) {
    if (!mainColor) {
      return
    }
    var cssText = cssTemplate
    cssText = cssText.replace(/\{mainColor\}/g, '#' + mainColor).replace(/[\s\r\n]+/gi, ' ')

    var sty = document.createElement('style')

    sty.textContent = cssText

    // 样式节点追加到页面head标签尾部
    document.head.appendChild(sty)
  },
  appendBackColor (color) {
    if (!color) {
      return
    }
    var cssText = `html{background:{color} !important;}`
    cssText = cssText.replace(/\{color\}/g, '#' + color).replace(/[\s\r\n]+/gi, ' ')

    var sty = document.createElement('style')

    sty.textContent = cssText

    // 样式节点追加到页面head标签尾部
    document.head.appendChild(sty)
  },
  /**
   * 简单复制object属性
   * 将源对象自身属性复制到接收对象上
   * @param {object} ori
   * => 接收对象
   * @param {object} src
   * => 源对象
   */
  merge (ori, src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        ori[key] = src[key]
      }
    }
  },
  /**
   * 简单复制object属性
   * 将源对象自身属性复制到接收对象上
   * @param {object} ori
   * => 接收对象
   * @param {object} src
   * => 源对象
   */
  getUrlSearch (name) {
    // 统一转小写
    name = name.toLowerCase()
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != undefined) {
      try {
        return decodeURIComponent(r[2])
      } catch (_e) {
        return null
      }
    }
    return null
  },
  isTypeOf (_data, _type) {
    try {
      _type = _type.toLowerCase()
      if (_data === null) return _type === 'null'
      if (_data === undefined) return _type === 'undefined'
      return Object.prototype.toString.call(_data).toLowerCase() === '[object ' + _type + ']'
    } catch (e) {
      return !1
    }
  },
  isFunction (_data) {
    return this.isTypeOf(_data, 'function')
  },
  isData (_data) {
    return this.isTypeOf(_data, 'date')
  },
  isArray (_data) {
    return this.isTypeOf(_data, 'array')
  },
  isObject (_data) {
    return this.isTypeOf(_data, 'object')
  },
  encrypt (t1, t2) {
    var key = window.RSA.getPublicKey(PUB)
    return window.RSA.encrypt(t1 + '`' + t2, key)
  },
  encrypt2 (t1) {
    var key = window.RSA.getPublicKey(PUB)
    return window.RSA.encrypt(t1, key)
  },
  getCookie (name) {
    var arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

    if (arr = document.cookie.match(reg))      { return decodeURIComponent(arr[2])}    else      { return undefined}
  },
  setCookie (opt) {
    var cookieText = encodeURIComponent(opt.name) + '=' +
      encodeURIComponent(opt.value)
    if (this.isData(opt.expires)) {
      cookieText += ' ; expires=' + opt.expires.toGMTString()
    }
    if (opt.path) {
      cookieText += ' ; path=' + opt.path
    }
    if (opt.domain) {
      cookieText += ' ; domain=' + opt.domain
    }
    if (opt.secure) {
      cookieText += ' ; secure'
    }
    document.cookie = cookieText
  },
  getRtid () {
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
      size = 32,
      arr = []
    while (size-- > 0) {
      arr[size] = (chars.charAt(Math.random() * chars.length))
    }
    return arr.join('')
  },
  getUtid () {
    let utid = this.getCookie('utid')
    if (utid === undefined) {
      utid = this.getRtid()
      let date = new Date()
      // 过期时间为 10年后，不同浏览器有一个最大过期时间的限制，safari最大是7天，chrome是400天，firfox可达9年，360可设置到10年。
      date.setTime(date.getTime() + 10 * 365 * 24 * 60 * 60 * 1000)
      this.setCookie({
        name: 'utid',
        value: utid,
        expires: date,
        path: '/'
      })
    }
    return utid
  },
  _doFlLog: (function () {
    var _infoList = ['device_name', 'user_agent', 'language', 'color_depth', 'pixel_ratio', 'hardware_concurrency', 'computer_screen', 'browser_window_size', 'timezone_offset', 'regular_plugins', 'js_fonts', 'webgl_vendor', 'touch_support', 'canvas', 'webgl', 'HTTP_ACCEPT_Headers']
    var _infoList2 = ['dn', 'ua', 'la', 'cd', 'pr', 'hc', 'cs', 'bws', 'tzo', 'plg', 'jsf', 'wv', 'ts', 'ca', 'wgl', 'hah']
    var _formatDi = function (_fpobj) {
      var _di,
        _plg
      if (_fpobj && _fpobj.di) {
        _di = JSON.parse(_fpobj.di)
        if (_di.plg) {
          _plg = _di.plg
          for (var i = 0, l = _plg.length, item; i < l; i++) {
            item = _plg[i]
            item = item.split(':')[0]
            _plg[i] = item
          }
        }
        _di.plg = _plg
        _fpobj.di = JSON.stringify(_di)
      }
      return _fpobj
    }
    var _sendPF = function (_fpobj) {
      _fpobj.src = 'WEBZJ'
      _fpobj.time = new Date().getTime()
      var _src = '//fl.reg.163.com/urs/__utm.gif?'
      if (window.$NEEDV6) {
        _src = '//fl-v6.reg.163.com/urs/__utm.gif?'
      }
      var _tempArr = []
      _fpobj = _formatDi(_fpobj)
      for (var _o in _fpobj) {
        _tempArr.push(encodeURIComponent(_o) + '=' + encodeURIComponent(_fpobj[_o]))
      }
      _src = _src + _tempArr.join('&')
      var _img = document.createElement('img')
      _img.style.position = 'absolute'
      _img.style.height = '0px'
      _img.style.width = '0px'
      document.body.appendChild(_img)
      _img.src = _src
      // 10秒后移除节点
      setTimeout(function () {
        document.body.removeChild(_img)
      }, 10000)
    }
    var _getBrowserInfo2 = function (_utid, _rtid) {
      var _fpobj = {}
      var _di = {
        'page': 2
      }
      _di['from'] = 'webzj-h5dl'
      _fpobj.di = JSON.stringify(_di)
      _fpobj.utid = _utid
      _fpobj.rtid = _rtid
      _sendPF(_fpobj)
    }
    var _getBrowserInfo = function (_utid, _rtid, that) {
      try {
        var _fp = new Fingerprint2()
        _fp.get(function (result, components) {
          var _di = {},
            _temp = {},
            _fpobj = {},
            _jsf,
            _jsfList = []
          _di['from'] = 'webzj-h5dl'
          var _ursfp = that.getCookie('NTES_WEB_FP');
          if (_ursfp){
            result = _ursfp||''
          }else{
            let date = new Date()
            // 过期时间为 30 天
            date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000)
              that.setCookie({
                name: 'NTES_WEB_FP',
                value: result||'',
                expires: date,
                path:'/'
              });
          }
          _di['fp'] = result || ''

          for (var _i = 0, _item; _i < components.length; _i++) {
            _item = components[_i]
            _temp[_item.key] = _item.value
          }
          for (var i = 0, _item1, _item2, l = _infoList.length; i < l; i++) {
            _item1 = _infoList[i]
            _item2 = _infoList2[i]
            _di[_item2] = _temp[_item1] || ''
          }
          _jsf = _di['jsf']
          _jsfList = []
          for (var _k = 0, _j; _k < _jsf.length; _k++) {
            _j = _jsf[_k]
            var _fj = _j.substring(0, 1)
            _jsfList.push(_fj)
          }
          _jsf = _jsfList.join('')
          _di['jsf'] = _jsf.length + '-' + md5(_jsf)
          _di['ca'] = _fp.x64hash128(_di['ca'])
          _di['wgl'] = _fp.x64hash128(_di['wgl'])
          _di.page = 1
          _di = JSON.stringify(_di)
          _fpobj.di = _di
          _fpobj.utid = _utid
          _fpobj.rtid = _rtid
          _sendPF(_fpobj)
        })
      } catch (e) {
        _getBrowserInfo2(_utid, _rtid)
      }
    };
    return function (_utid, _rtid) {
      var that = this;
      setTimeout(function () {
        _getBrowserInfo(_utid, _rtid, that)
      }, 200)
    }
  })(),
  sendZwlog:function(_index){
      var img = document.createElement('img');
      img.src='https://pr.nss.netease.com/sentry/passive?uapi=h5maildl&dataTime=0&clusterName=urs-webzj-static-passive&modelName=webzj_response_h5maildl&one=1&url='+_index;
  },
  getSmState () {
    return NEEDSM
  },
  doSm4 (data) {
    return {
      encParams: sm4.encrypt(data, sm4pubkey)
    }
  },
  objToParams (object) {
    let list = []
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key] || ''
        list.push(`${key}=${element}`)
      }
    }
    return list.join('&')
  },
  getImgUrl (opd, un) {
    let host = '/dl'
    let data = {
      pd: ucon.product,
      pkid: ucon.promark,
      opd: opd,
      rtid: this.getRtid()
    }
    if (un) {
      data.un = un
    }
    let time = new Date().getTime()
    if (NEEDSM) {
      data.channel = 0
      data = JSON.stringify(data)
      let newData = this.doSm4(data)
      newData.nocache = time
      // 直接修改变量的值
      host = '/dl/zj/mail'
      // 国密没有特殊字符，url可以不做encode
      return host + '/cp?' + this.objToParams(newData)
    } else {
      data.nocache = time
      // 没有特殊字符，url可以不做encode
      return host + '/cp?' + this.objToParams(data)
    }
  },
  isCanSmUrl (url) {
    var path = url.split('?')[0] || ''
    return /\/dl\/common\/setCookie$/.test(path)
  },
  tryAddSm (_url) {
    var _search,
      _path,
      _urlList,
      _paramobj,
      _tempurl,
      _encParams
    if (this.getSmState() && this.isCanSmUrl(_url)) {
      _urlList = _url.split('?')
      _path = _urlList[0] || ''
      _search = _urlList[1] || ''
      if (_search) {
        _paramobj = {}
        _search = _search.split('&')
        _search.forEach(_item => {
          var _itemList = _item.split('=')
          if (_itemList[ 0 ]){
            _paramobj[ _itemList[ 0 ] ] = _itemList[ 1 ] || ''
          }
        })
      }
      var _paramobjstr = JSON.stringify(_paramobj)
      _encParams = this.doSm4(_paramobjstr).encParams
      _tempurl = _search ? _path + '?encParams=' + _encParams : _path
      return {
        realurl: _tempurl,
        paramobj: _paramobj
      }
    } else {
      return {
        realurl: _url
      }
    }
  },

  hasPuzzle (data) {
    return data && data.args && data.args.puzzle;
  },

  getParams ( obj, splitstr ) {
    var paramsArray = []
    for ( var key in obj ) {
        let param = key + `=` + obj[ key ]
        paramsArray.push( param )
    }
    return paramsArray.join( splitstr )
  },

  doNssLog (obj = {}) {
    const params = {
      clusterName: 'urs-webzj-static-passive',
        modelName: 'webzj_response_h5maildl',
        one: 1,
        dataTime: new Date().getTime()
    };
    const allParams = Object.assign({}, params, obj);
    for(let key in allParams){
      if (allParams[key] === 0){
        allParams[key] = `0`
      }
    }
    const paramStr = this.getParams(allParams, '&');

    try {
        var img = document.createElement( 'img' )
        img.src = `https://pr.nss.netease.com/sentry/passive?${paramStr}`
    } catch(e) {}
  },

  doNgLog: function(obj = {}) {
    try {
        const allParams = Object.assign({}, obj);
        const paramStr = this.getParams(allParams, '&');

        const img = new Image();
        img.src = `//dl.reg.163.com/UA1435545636633/__utm.gif?${paramStr}`;
        img.style.display = 'none';
        document.body.appendChild(img);
        setTimeout(() => {
            document.body.removeChild(img);
        }, 800);
    } catch(e) {}
  }
}



// WEBPACK FOOTER //
// ./src/util/util.js